import { INSURANCE_NAMES } from "../consts/insurance"

const { NONE, BASIC, PLUS } = INSURANCE_NAMES

// Due to AXA it's not possible to order insurance to following nationalities
// us - United states
// pr - Puerto Rico
// gu - Guam
// vi - U.S. Virgin Islands
// mp - Northern Mariana Islands
// "" - empty string - nationality not selected
const INSURANCE_NATIONALITY_BLACKLIST = ["us", "pr", "gu", "vi", "mp", "um"]

export function isInsuranceAllowedForNationality(nationality: string) {
  return !INSURANCE_NATIONALITY_BLACKLIST.includes(nationality)
}

export const serializeOldInsuranceName = (oldInsuranceName: string) => {
  switch (oldInsuranceName) {
    case "travel_plus":
      return PLUS
    case "travel_basic":
      return BASIC
    default:
      return NONE
  }
}
